/*
 * @TagTable.vue
 * @Description 历史进场组件
 * @Author 
 * @Date 
 */
<template>
  <div class="table-item-box _padding-l-none" style="padding: 10px;">
    <section style="height: 100%;">

      <!-- 表格 -->
      <el-table :data="tableInfos"
                ref="tableInfos"
                @sort-change="changeSort"
                stripe
                :class="{'table': true, 'no-pagination': false}"
      >
        <el-table-column v-for="(item, index) in colData" :key="index" :prop="item.value" :sortable="item.sort ? 'custom' : false" :sort-orders="item.sort ? filters.sortOrders : []" :label="item.title" v-if="item.isShow" :min-width="item.minWidth">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row[item.value]">{{scope.row[item.value]}}</span>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <Pagination
          :currentPage="pagination.currentPage"
          :total="pagination.total"
          :pageSize="pagination.limit"
          @handleSizeChangeSub="handleSizeChangeSub"
          @handleCurrentChangeSub="handleCurrentChangeSub"
      />

      <!--查询工具条-->
      <el-col style="text-align: left;">
        <el-form :inline="true" :model="filters" ref="filters" >
          <el-form-item>查询条件：</el-form-item>
          <el-select v-model="filters.typeId" style="width: 200px;margin-right: 10px;" placeholder="所有人员类型" @change="research();">
            <el-option v-for="(item, index) in userTypes" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-form-item prop="duration" class="item-cnt-lhfs-0">
            <el-date-picker
                :picker-options="filters.pickerOptions"
                v-model="filters.duration"
                type="daterange"
                range-separator="—"
                value-format="yyyy-MM-dd"
                start-placeholder="进场开始时间"
                end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-autocomplete
              :style="{width:'400px'}"
              ref="elautocomplete"
              class="inline-input"
              v-model="filters.keyword"
              :fetch-suggestions="querySearch"
              :placeholder="filters.placeholderOpt[filters.bindingType]"
              :trigger-on-focus="false"
              clearable
              @select="handleSelect"
              @keyup="changeStyle('block', '.el-autocomplete-suggestion')"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" @click="research()"></i>
          </el-autocomplete>
          <el-form-item style="position: absolute;top: 9px;right: 20px;margin: 0px;z-index: 3;">
            <el-button type="primary" icon="el-icon-download" trigger="click" @click="searchExportData">批量导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!-- ======================= 导出所需数据 =============================== -->
      <el-table :data="exportDatas"  id="out-table" stripe  style="display: none;" class="table">
        <el-table-column label="编号" min-width="80px">
          <template slot-scope="scope">
            {{scope.row.userNo}}
          </template>
        </el-table-column>
        <el-table-column label="姓名" min-width="80px">
          <template slot-scope="scope">
            {{scope.row.userName}}
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="80px">
          <template slot-scope="scope">
            {{scope.row.sex}}
          </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="60px">
          <template slot-scope="scope">
            {{scope.row.phone}}
          </template>
        </el-table-column>

        <el-table-column label="日期" min-width="80px">
          <template slot-scope="scope">
            {{scope.row.recordDateStr}}
          </template>
        </el-table-column>
        <el-table-column label="工时" min-width="60px">
          <template slot-scope="scope">
            {{scope.row.totalInDurationStr}}
          </template>
        </el-table-column>
        <el-table-column label="进出次数" min-width="60px">
          <template slot-scope="scope">
            {{scope.row.totalInTimes}}
          </template>
        </el-table-column>
      </el-table>

    </section>
  </div>

</template>

<script>
// 基站组件
import ApiApproach from '@/request/api-approach'
import Pagination from '@/components/Pagination'
// API 人员信息
import ApiUser from '@/request/api-user'
// 公用函数
import GlobalFun from '@/global/global-function'

export default {
  name: "ApproachAttendance",
  /**
   * @Des 组件引用
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  components: {
    Pagination
  },

  props:{
    userTypes: Array,
  },// props

  /**
   * @Des 数据定义
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  data() {
    return {
      /**
       * @Des 查询条件属性
       * @Auth jsh
       * @Date 09:41 2021/6/28
       */
      filters: {
        // 开始时间 - 结束时间
        duration: '',
        // 隐藏的时间
        pickerOptions: {
          disabledDate(v) {
            return v.getTime() > new Date().getTime()
          }
        },
        orderBy: {
          "userName": "asc",
          "recordDateStr": "asc"
        },
        sortOrders: [
          "ascending",
          "descending"
        ],
        // 类型
        typeId:'',
        // 关键词
        keyword: '',
        // 绑定类型
        bindingType: 1,
        // placeholder
        placeholderOpt: {1: '请输入人员姓名/编号',2: '请输入车辆类型/车牌号'},
        // 查询
        queryString: '',
        // 查询的绑定id
        bindingId: '',
      },
      colData: [
        {title: "编号", value:"userNo", isShow: true, minWidth: '100px'},
        {title: "姓名", value:"userName", isShow: true, minWidth: '100px', sort: true},
        {title: "性别", value:"sex", isShow: true, minWidth: '100px'},
        {title: "手机号", value:"phone", isShow: true, minWidth: '100px'},
        {title: "日期", value:"recordDateStr", isShow: true, minWidth: '100px', sort: true},
        {title: "工时", value:"totalInDurationStr", isShow: true, minWidth: '100px'},
        {title: "进出次数", value:"totalInTimes", isShow: true, minWidth: '100px'},
      ],
      users:[],
      colOptions: [], //默认全选
      colSelect: [],
      // 表格信息
      tableInfos:[],
      pagination:{
        total: 0,
        startNum: 0,
        limit: 50,
        currentPage: 1
      },
      exportDatas: []
    }
  },
  computed: {
  },
  created(){
    this.setDefaultTableTitle();
    this.search();
  },
  mounted(){
  },
  /**
   * @Des 监听
   * @Auth
   * @Date 2021/6/4
   */
  watch: {
    pagination: {
      handler(newVal, oldVal){
        this.search();
      },
      immediate: true,
      deep:true,
    }
  },
  /**
   * @Des 方法定义
   * @Auth jsh
   * @Date 09:42 2021/6/28
   */
  methods: {
    /**
     * 设置默认选中的表头
     * */
    setDefaultTableTitle(){
      this.colOptions = [];
      this.colSelect = [];
      this.colData.forEach((row, index) => {
        this.colOptions.push(row.title);
        this.colSelect.push(row.title);
      })
    },

    /**
     * 重新搜索
     * */
    research(){
      this.pagination.total = 0;
      this.pagination.startNum = 0;
      this.search();
    },
    /**
     * @Des 查询基站
     * @Auth jsh
     * @Date 09:42 2021/6/28
     */
    search() {
      let startTime = '';
      let endTime = '';
      if (this.filters.duration) {
        startTime = this.filters.duration[0];
        endTime = this.filters.duration[1];
      }else{
        startTime = this.$moment(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).format('YYYY-MM-DD');
        endTime = this.$moment(new Date()).format('YYYY-MM-DD');
        this.filters.duration = [startTime, endTime];
      }
      this.$request.postJsonRequest(ApiApproach.searchInoutStatisticsApi, {
        projectId: this.$store.state.currentProjectId,
        typeId: this.filters.typeId.replace("T", ""),
        userId: this.filters.bindingId,
        startDate: startTime,
        endDate: endTime,
        orderBy: {
          record_date: 'desc'
        },
        total: this.pagination.total,
        startNum: this.pagination.startNum,
        limit: this.pagination.limit
      }).then(result => {
        this.tableInfos = Object.assign([], []);
        this.pagination.total = result.total;
        this.tableInfos = result.rows;
      }).catch(error => {
        console.error('查询进出人员统计异常', ApiApproach.searchInoutApi, error);
      })
    },
    /**
     * 改变排序
     * */
    changeSort(data){
      let prop = data.prop;
      let order = data.order;

      this.tableInfos.sort((a, b) => {
        if (order == 'ascending') return String(a[prop]).localeCompare(String(b[prop]));
        if (order == 'descending') return String(b[prop]).localeCompare(String(a[prop]));
      });

    },
    /**
     * @Des 当前页数据改变
     * @Auth
     * @Date 2021/6/4
     */
    handleCurrentChangeSub(val){
      this.pagination.currentPage = val;
      this.pagination.startNum = this.pagination.limit * (val-1);
    },
    /**
     * @Des 页长度改变
     * @Auth
     * @Date 2021/6/4
     */
    handleSizeChangeSub(val){
      this.pagination.limit = val;
      this.pagination.currentPage = 1;
      this.pagination.startNum = 0;
    },
    /**
     * 是否选择
     * */
    checkSelectable(row){
      return true;
    },
    /**
     * @Des 匹配建议
     * @Auth
     * @Date 2021/8/17
     */
    querySearch(queryString, callback) {
      if(queryString == ''){
        this.changeStyle('none', '.el-autocomplete-suggestion');
        return;
      }
      switch(this.filters.bindingType) {
        case 1:
          this.searchUser(callback);
          break;
        default :
          break;
      }
    },
    /**
     * @Des 选择建议
     * @Auth
     * @Date 2021/8/17
     */
    handleSelect(item) {
      if(item.id == '0'){
        this.filters.bindingId = '';
        this.filters.keyword = '';
        return false;
      }
      this.filters.bindingId = item.id;
      this.trackObj = item;
    },
    /**
     * @Des 查询人员
     * @Auth
     * @Date 2021/8/17
     */
    searchUser(callback){
      this.$request.postJsonRequest(ApiUser.searchUserApi,{
        keyword: this.filters.keyword,
        projectId: this.$store.state.currentProjectId,
        orderBy: {
          user_name: 'asc'
        }
      }).then(result => {
        // console.log(result)
        // 人员 list
        this.users = result.rows;
        result.rows.forEach((row, index) => {
          row.value = row.idCard + "：" + row.userName;
          row.id = row.userId;
        })
        if(this.users.length > 0){
          callback && callback(this.users);
        }else{
          callback && callback([{value: '未匹配到人员', id: '0'}]);
        }
      }).catch(error => {
        console.error('查询人员异常', ApiUser.searchUserApi, error);
      })
    },
    /**
     * @Description 数据导出
     * @Date 10:09 2022/9/23
     * @Param
     * @Return
     */
    searchExportData() {
      let startTime = '';
      let endTime = '';
      if (this.filters.duration) {
        startTime = this.filters.duration[0];
        endTime = this.filters.duration[1];
      }else{
        startTime = this.$moment(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).format('YYYY-MM-DD');
        endTime = this.$moment(new Date()).format('YYYY-MM-DD');
        this.filters.duration = [startTime, endTime];
      }
      this.$request.postJsonRequest(ApiApproach.exportInoutStatisticsApi, {
        projectId: this.$store.state.currentProjectId,
        typeId: this.filters.typeId.replace("T", ""),
        userId: this.filters.bindingId,
        startDate: startTime,
        endDate: endTime,
        orderBy: {
          record_date: 'desc'
        }
      }).then(result => {
        this.exportDatas = [];
        if(result.total > 0){
          this.exportDatas = result.rows;
        }
        // 就绪后 执行
        this.$nextTick(() => {
          console.log(this.exportDatas);
          GlobalFun.exportExcel(document.querySelector("#out-table"),'考勤记录.xlsx');
        });

      }).catch(error => {
        console.error('导出进出人员统计异常', ApiApproach.searchInoutApi, error);
      })
    },
      /**
     * @Des 改变样式
     * @Auth
     * @Date 2021/8/17
     */
    changeStyle(status, className){
      let dom = document.querySelectorAll(className);
      dom[0].style.display = status;
    },
  },


}
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Approach/ApproachAttendance.vue